
export namespace BcCurriculum {
    export class Load {
        static readonly type = '[BcCurriculum] Load';
    }
}